<sm-toolbar>
    <p-button icon="fas fa-cog" label="Persistent Storage öffnen" (onClick)="openPersistentStorage()"></p-button>
    <p-button icon="fas fa-cog" label="Dateisystemberechtigungen aktualisieren" (onClick)="grantAllFileSystemRights()"></p-button>
    <p-button icon="fas fa-cog" label="Alte Log-Dateien zippen" (onClick)="zipLogFiles()"></p-button>
    <p-button icon="fas fa-cog" label="enaio Fehlermeldung interpretieren" (onClick)="interpretEnaioErrorMessage()"></p-button>
</sm-toolbar>
<app-progressor-overlay *ngIf="progressor != null" [progressor]="progressor.value"></app-progressor-overlay>
